import DatesManagement from "./DatesManagement.view";

export default DatesManagement;
